module.exports = __webpack_public_path__ + "assets/img/Instagram.93e2ade8.jpg";